import React from 'react';

const AvatorIcon = ({ width = 60, height = 60 }) => {
  return (
    <svg width={width} height={height} cursor="pointer" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44.955 46.8127C43.2082 44.4999 40.9482 42.6243 38.353 41.3337C35.7578 40.043 32.8984 39.3726 30 39.3752C27.1016 39.3726 24.2422 40.043 21.6471 41.3337C19.0519 42.6243 16.7919 44.4999 15.045 46.8127M44.955 46.8127C48.3638 43.7807 50.7678 39.7841 51.853 35.353C52.9382 30.9218 52.6507 26.2655 51.0287 22.0014C49.4067 17.7374 46.5268 14.0672 42.771 11.4775C39.0152 8.88778 34.5609 7.50098 29.9988 7.50098C25.4367 7.50098 20.9824 8.88778 17.2265 11.4775C13.4707 14.0672 10.5909 17.7374 8.96887 22.0014C7.34688 26.2655 7.05941 30.9218 8.14458 35.353C9.22975 39.7841 11.6363 43.7807 15.045 46.8127M44.955 46.8127C40.8401 50.4832 35.5141 52.5081 30 52.5002C24.4851 52.5087 19.1606 50.4838 15.045 46.8127M37.5 24.3752C37.5 26.3644 36.7099 28.272 35.3033 29.6785C33.8968 31.0851 31.9892 31.8752 30 31.8752C28.0109 31.8752 26.1033 31.0851 24.6967 29.6785C23.2902 28.272 22.5 26.3644 22.5 24.3752C22.5 22.3861 23.2902 20.4785 24.6967 19.0719C26.1033 17.6654 28.0109 16.8752 30 16.8752C31.9892 16.8752 33.8968 17.6654 35.3033 19.0719C36.7099 20.4785 37.5 22.3861 37.5 24.3752Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AvatorIcon;
